import React, {
	createContext,
	Context,
	useState,
	useEffect,
	useContext,
} from 'react'
import { useTranslation } from 'react-i18next'

import { CircleSpinner } from 'shared/components/Spinners'

import { IOtpSessionResponse } from 'selfServicePortal/interfaces/i-api-sdd'

import { SddDispatchContext, SDD_ACTIONS } from '../SDDMultistepValues'
import { AuthError } from './SDDAuthenticationBlocks/AuthError'
import { AuthSelectButtons } from './SDDAuthenticationBlocks/AuthSelectButtons'
import { AuthValidation } from './SDDAuthenticationBlocks/AuthValidation'
interface IAuthContext {
	loading: boolean | undefined
	setLoading: Function
	otpSessionResponse: IOtpSessionResponse | undefined
	setOtpSessionResponse: Function
	otpCode: string | undefined
	setOtpCode: Function
	authSelect: boolean | undefined
	setAuthSelect: Function
	err: boolean | undefined
	setErr: Function
}

export const AuthContext: Context<IAuthContext> = createContext<IAuthContext>({
	loading: false,
	setLoading: () => {},
	otpSessionResponse: undefined,
	setOtpSessionResponse: () => {},
	otpCode: undefined,
	setOtpCode: () => {},
	authSelect: true,
	setAuthSelect: () => {},
	err: false,
	setErr: () => {},
})

export const SDDAuthentication = () => {
	const [sdd, dispatchSdd] = useContext(SddDispatchContext) // eslint-disable-line @typescript-eslint/no-unused-vars
	const [otpSessionResponse, setOtpSessionResponse] =
		useState<IOtpSessionResponse>()

	const { t } = useTranslation()
	const [authSelect, setAuthSelect] = useState<boolean>(true)
	const [otpCode, setOtpCode] = useState<string>()
	const [loading, setLoading] = useState<boolean>(false)
	const [err, setErr] = useState<boolean>(false)

	useEffect(() => {
		if (err) {
			dispatchSdd({
				type: SDD_ACTIONS.SET_DESCRIPTION,
				payload: {
					description: '',
				},
			})
		}
		return
	}, [err, dispatchSdd])

	return (
		<AuthContext.Provider
			value={{
				otpSessionResponse,
				setOtpSessionResponse,
				otpCode,
				setOtpCode,
				authSelect,
				setAuthSelect,
				loading,
				setLoading,
				err,
				setErr,
			}}>
			<div className="sdd-authentication-section">
				<div className="sdd-authentication-method-select">
					{loading && (
						<div className="sdd-loading">
							<CircleSpinner />
							{authSelect ? <></> : <div>{t('Loading')}</div>}
						</div>
					)}
					{!err && !loading && (
						<>
							{authSelect ? (
								<div className="sdd-otp-method-select-section">
									<AuthSelectButtons />
								</div>
							) : (
								<div className="sdd-otp-validation-section">
									<AuthValidation />
								</div>
							)}
						</>
					)}
					{err && !loading && <AuthError />}
				</div>
			</div>
		</AuthContext.Provider>
	)
}
